import React, {PropTypes as T} from 'react';
import translate from '../../../../utils/translate';
import PriceCategory from '../pricecategory';

export default class ISMFilters extends React.Component {
  static propTypes = {
    filters: T.object,
    isMobile: T.bool
  };

  renderPriceCategories = () => {
    const categoryIds = Object.keys(this.props.filters.priceCategories);
    return categoryIds.map(function (priceCategoryId) {
      const priceCategory = this.props.filters.priceCategories[priceCategoryId];
      const isActive = this.props.filters.activeCategory === priceCategoryId;
      const isAvailable = this.props.filters.activePriceCategoryIds
      .indexOf(priceCategoryId) !== -1;

      return <PriceCategory
        id={priceCategoryId}
        key={priceCategoryId}
        {...priceCategory}
        isActive={isActive}
        isAvailable={isAvailable} />;
    }, this);
  };

  // Returns the service fee messaging for mobile.
  renderServiceFeeMessage = () => {
    const chargeRange = this.props.filters.chargeRange;
    if (this.props.isMobile && chargeRange && chargeRange.length) {
      return <p
        className="pricefilter__category__charges--mobile"
        data-component="price-category-fee-message-mobile">{chargeRange}</p>;
    }
  };

  render () {
    const allPrices = {
      id:          null,
      isActive:    this.props.filters.activeCategory === null,
      isAvailable: true,
      code: translate('pageTranslations', 'PRICE_CATEGORY_FILTER_ANY_PRICES'),
      priceRange:  ''
    };

    return (
      <div className="pricefilter">
        <ul className="pricefilter__categories">
          <PriceCategory {...allPrices} />
          {this.renderPriceCategories()}
        </ul>
        {this.renderServiceFeeMessage()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/sidebar/filters/index.js